import React, { useEffect, useState, } from 'react';
import '../admin.list.scss';
import { useTranslation, } from 'react-i18next';
import { useNavigate, } from 'react-router-dom';
import { ColumnsType, SorterResult, } from 'antd/lib/table/interface';
import { IPreviewJourneyTrigger, TJourneyTriggerSortableListCol, } from 'atlas-shared';
import { Table, } from 'antd';
import { AdminListPageHeader, ListPageEmpty, } from '@Components';
import { IWithListProps, IWithListSorterProps, withList, } from '@Hocs/with.list';
import { useAbilities, useAuth, useJourneyTriggers, useOrganizations, useJourneies, } from '@Hooks';
import { JourneyTriggerListColumns, } from '@Utils';
import { IAuth, } from '@Store';

const JourneyTriggerList = ({ filters, filtersCount, hasFilters, sorter, pagination, setQueryParams, resetQueryParams, }: IWithListProps<IPreviewJourneyTrigger, TJourneyTriggerSortableListCol>) => {
  const { t, } = useTranslation();
  const navigate = useNavigate();
  const auth: IAuth = useAuth();
  const journey_triggers = useJourneyTriggers();
  const abilities = useAbilities();
  const [loading, setLoading, ] = useState<boolean>(true);
  const [rows, setRows, ] = useState<Array<any>>([]);
  const organizations = useOrganizations();
  const journeies = useJourneies();
  
  useEffect(() => {
    if (!journey_triggers.loaded)
      return;
      
    setLoading(false);
    setRows((journey_triggers?.journey_triggers || []).map(row => ({ ...row, key: row.id, })));
    
  }, [journey_triggers, ]);

  const columns: ColumnsType<IPreviewJourneyTrigger> = React.useMemo(() => {
    return JourneyTriggerListColumns(t, navigate, false, organizations, journeies, abilities, auth, [], filters, sorter);
  }, [t, navigate, organizations, journeies, abilities, auth, filters, sorter, ]);

  return <div className='admin-list-view'>
    <AdminListPageHeader 
      t={t}
      title={t('JOURNEY_TRIGGERS')}
      filtersCount={filtersCount}
      reset={() => resetQueryParams()}
         
    />
    <div className='table-wrp'>
      <Table
        key={loading ? 1 : 0}
        columns={columns}
        dataSource={rows}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
        }}
        onChange={(pagination, filters, _sorter) => {
          const sorter: Array<SorterResult<any>> = Array.isArray(_sorter) ? _sorter : _sorter?.columnKey ? [_sorter, ] : [];

          setQueryParams({
            pagination: { current: pagination.current as number, pageSize: pagination.pageSize as number, },
            filters: Object.fromEntries(Object.entries(filters).filter(([key, value, ]) => value !== null)),
            sorter: sorter
              .filter(s => !!s.order)
              .map(s => ({ column: s.columnKey as TJourneyTriggerSortableListCol, order: s.order as IWithListSorterProps<IPreviewJourneyTrigger, TJourneyTriggerSortableListCol>['order'], })),
          });
        }}
        locale={{
          emptyText: <ListPageEmpty t={t} hasFilters={hasFilters} hasRows={!!rows.length} reset={() => resetQueryParams()} />,
        }}
      />
    </div>
  </div>;
};

export const JourneyTriggerListView = React.memo(withList<IPreviewJourneyTrigger, TJourneyTriggerSortableListCol>(JourneyTriggerList, {
  filters: {},
  sorter: [{ column: 'created_at', order: 'descend', }, ],
  pagination: { current: 1, pageSize: 10, },
}));
